import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchAllProjects } from '../../../../store/slices/projectsSlice';
import { fetchLeads } from '../../../../store/slices/leadsSlice';
import { isProjectLinkedToLostLead } from '../../../../utils/syncLeadProjectBucketStatus';

const OPMyRequestPM = ({
    EmpEmail,
    setShowprojectrequestPM,
    setShowaprovedPM,
    setShowassignPM,
    setShowongoingPM,
    setShowcompletePM,
    showprojectrequestPM,
    showaprovedPM,
    showassignPM,
    showongoingPM,
    showcompletePM,
    SetrequestedprojectsDataPM,
    setApprovedProjectsManagerDataPM,
    setAssignedProjectsManagerDataPM,
    setOngoingProjectsManagerDataPM,
    requestedprojectsDataPM,
    approvedProjectsManagerDataPM,
    assignedProjectsManagerDataPM,
    ongoingProjectsManagerDataPM,
    completeProjectsManagerDataPM,
    setProjectsRequestDataPM,
    projectsRequestDataPM,
    setCompleteProjectsManagerDataPM

}) => {
    const LoggedUser = EmpEmail;
    const dispatch = useDispatch();
    
    const { projects } = useSelector((state) => state.projects);
    const { leads } = useSelector((state) => state.leads);
    const [unreadleadcountrequest, ] = useState([]);
    const [unreadleadcountapproved, ] = useState([]);
    const [unreadleadcountassign, ] = useState([]);
    const [unreadleadcountongoing, ] = useState([]);
    const [unreadleadcountcomplete, ] = useState([])

    useEffect(() => {
        dispatch(fetchLeads());
    }, [dispatch]);

    const handleprojectRequest = (projecttype) => {
        // handleTabClick("ProjectRequests");
        setShowprojectrequestPM(!showprojectrequestPM);
        setShowaprovedPM(false);
        setShowassignPM(false);
        setShowongoingPM(false);
        setShowcompletePM(false);
        // setShowprojectrequestPM(true);
        dispatch(fetchAllProjects());
    };

    const handleprojectAssign = (projecttype) => {
        setShowassignPM(!showassignPM);
        setShowprojectrequestPM(false);
        setShowaprovedPM(false);
        setShowongoingPM(false);
        setShowcompletePM(false);
        // handleTabClick("projectAssign");
    };
    const handleprojectOngoing = (projecttype) => {
        setShowongoingPM(!showongoingPM);
        setShowassignPM(false);
        setShowprojectrequestPM(false);
        setShowaprovedPM(false);
        setShowcompletePM(false);
        // handleTabClick("projectOngoing");
    };
    const handleprojectCompleted = (projecttype) => {
        setShowcompletePM(!showcompletePM);
        setShowongoingPM(false);
        setShowassignPM(false);
        setShowprojectrequestPM(false);
        setShowaprovedPM(false);
        // handleTabClick("projectCompleted");
    };

    const handleprojectApproved = () => {
        setShowaprovedPM(!showaprovedPM);
        setShowcompletePM(false);
        setShowongoingPM(false);
        setShowassignPM(false);
        setShowprojectrequestPM(false);
        // handleTabClick("ProjectApproved"); 
    };

    // useEffect(() => {
    //     const filtered = projects.filter(
    //         (proj) =>
    //             Array.isArray(proj.Assignedperson) &&
    //             proj.Assignedperson.some(
    //                 (person) => person.managerstatus === "project requested"
    //             )
    //     );
    //     const managerProjects = filtered.filter((proj) =>
    //         proj.Assignedperson?.some(
    //             (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
    //         )
    //     );

    //     console.log("fasfasf requested", managerProjects )
    //     Setrequestedprojects(managerProjects);
    // }, [projects, LoggedUser]);

    useEffect(() => {


        const filteredProjects = projects.filter(
            // const filteredProjects = projects.filter(
            (project) =>
                project.ProjectManagerStatus === "project requested" &&
                Array.isArray(project.Assignedperson) &&
                project.Assignedperson.some(
                    (person) => person.email === LoggedUser && (person?.manageraction !== "cancelled" || person?.operationstatus !== "project not-approved")
                ) &&
                !isProjectLinkedToLostLead(project, leads)
                // project.Assignedperson.some(
                //     (person) => person.email === LoggedUser &&
                //         (person?.manageraction !== "cancelled" || person?.operationstatus !== "project not-approved" || person?.operationstatus !== "project approved")
                // )
        );
        console.log("gdfgdfg filteredProjects", filteredProjects)
        setProjectsRequestDataPM(filteredProjects);
    }, [projects, setProjectsRequestDataPM, LoggedUser, leads]);

    useEffect(() => {
        if (!projectsRequestDataPM) return;

        const allProjectArrays = [
            approvedProjectsManagerDataPM,
            assignedProjectsManagerDataPM,
            ongoingProjectsManagerDataPM,
            completeProjectsManagerDataPM,
        ];

        const getQuotationId = (p) => p?.quotationId ?? p?.QuotationId ?? null;
        const updatedProjects = projectsRequestDataPM.filter((requestProject) => {
            const isMatched = allProjectArrays.some((projectArray) =>
                projectArray?.some(
                    (project) => {
                        const qId1 = getQuotationId(project);
                        const qId2 = getQuotationId(requestProject);
                        if (qId1 != null && qId2 != null) {
                            return String(qId1) === String(qId2);
                        }
                        return project.ProjectName === requestProject.ProjectName &&
                            project.TypeService === requestProject.TypeService;
                    }
                )
            );
            return !isMatched;
        });
        console.log("fasfasf requested", updatedProjects)

        SetrequestedprojectsDataPM(updatedProjects);
    }, [
        projectsRequestDataPM,
        approvedProjectsManagerDataPM,
        assignedProjectsManagerDataPM,
        ongoingProjectsManagerDataPM,
        completeProjectsManagerDataPM,
        SetrequestedprojectsDataPM
    ]);


    // useEffect(() => {
    //     const filtered = projects.filter(
    //         (proj) =>
    //             Array.isArray(proj.Assignedperson) &&
    //             proj.Assignedperson.some(
    //                 (person) => person.managerstatus === "project approved"
    //             )
    //     );
    //     const managerProjects = filtered.filter((proj) =>
    //         proj.Assignedperson?.some(
    //             (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
    //         )
    //     );

    //     console.log("fasfasf approved", managerProjects)

    //     setApprovedProjectsManager(managerProjects);
    // }, [projects, LoggedUser]);

    useEffect(() => {
        if (!Array.isArray(projects) || !LoggedUser) return; // safety check

        const filtered = projects.filter(
            (proj) =>
                Array.isArray(proj.Assignedperson) &&
                proj.Assignedperson.some(
                    (person) => person.operationstatus === "project approved"
                ) &&
                !isProjectLinkedToLostLead(proj, leads)
        );
        const managerProjects = filtered.filter((proj) =>
            proj.Assignedperson?.some(
                (person) => person.email?.toLowerCase() === LoggedUser.toLowerCase()
            )
        );
        console.log("fasfasf approved", managerProjects)

        setApprovedProjectsManagerDataPM(Array.isArray(managerProjects) ? managerProjects : []);
    }, [projects, setApprovedProjectsManagerDataPM, LoggedUser, leads]);



    useEffect(() => {
        const filtered = projects.filter(
            (proj) =>
                Array.isArray(proj.Assignedperson) &&
                proj.Assignedperson.some(
                    (person) => person.managerstatus === "project assigned"
                ) &&
                !isProjectLinkedToLostLead(proj, leads)
        );
        const managerProjects = filtered.filter((proj) =>
            proj.Assignedperson?.some(
                (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
            )
        );
        console.log("fasfasf assigned", managerProjects)

        setAssignedProjectsManagerDataPM(managerProjects);
    }, [projects, setAssignedProjectsManagerDataPM, LoggedUser, leads]);


    useEffect(() => {
        const filtered = projects.filter(
            (proj) =>
                Array.isArray(proj.Assignedperson) &&
                proj.Assignedperson.some(
                    (person) => person.managerstatus === "project ongoing"
                ) &&
                !isProjectLinkedToLostLead(proj, leads)
        );
        const managerProjects = filtered.filter((proj) =>
            proj.Assignedperson?.some(
                (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
            )
        );
        console.log("fasfasf ongoing", managerProjects)

        setOngoingProjectsManagerDataPM(managerProjects);
    }, [projects, setOngoingProjectsManagerDataPM, LoggedUser, leads]);

    useEffect(() => {
        const filtered = projects.filter(
            (proj) =>
                Array.isArray(proj.Assignedperson) &&
                proj.Assignedperson.some(
                    (person) => person.managerstatus === "project complete"
                ) &&
                !isProjectLinkedToLostLead(proj, leads)
        );
        const managerProjects = filtered.filter((proj) =>
            proj.Assignedperson?.some(
                (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
            )
        );
        console.log("fasfasf complete", managerProjects)

        setCompleteProjectsManagerDataPM(managerProjects);
    }, [projects, setCompleteProjectsManagerDataPM, LoggedUser, leads]);

    return (
        <div className="w-[40%]  relative bg-white rounded-md pl-2 pr-2">
            <div className="mt-3">
                <div className="bg-[#e8e8e8] border border-gray-400 text-black text-center py-2 rounded-t-lg font-semibold">
                    My Requests
                </div>
                <div className="flex w-full pt-5 p-2">
                    <div className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center">
                        <div className="w-[20%] flex justify-center">
                            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                                Project Requests
                            </p>
                        </div>
                        <div
                            onClick={() => {
                                handleprojectRequest("projectRequest");
                            }}
                            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showprojectrequestPM
                                ? "bg-blue-900 border-[#3a1e0a] shadow-lg"
                                : "bg-[#4e95d9] border-[#5A3D2B]"
                                }`}
                            style={{ borderColor: "#5A3D2B" }}
                        >
                            {unreadleadcountrequest.length > 0 && (
                                <div className="absolute top-3 flex justify-center align-middle items-center">
                                    {/* <NotificationsActiveIcon
                                  className="text-black w-6 h-6"
                                /> */}
                                    <span className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                        {unreadleadcountrequest.length}
                                    </span>
                                </div>
                            )}

                            <span
                                className={`text-white ${unreadleadcountrequest.length > 0
                                    ? "text-2xl font-semibold"
                                    : "text-lg"
                                    } font-semibold`}
                            >
                                {requestedprojectsDataPM.length}
                            </span>
                            {showprojectrequestPM && (
                                <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                            )}
                        </div>
                    </div>
                    <div className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center">
                        <div className="w-[20%] flex justify-center">
                            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                                Project Approved
                            </p>
                        </div>

                        <div
                            onClick={() => {
                                handleprojectApproved();
                            }}
                            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showaprovedPM
                                ? "bg-yellow-600 border-[#3a1e0a] shadow-lg"
                                : "bg-[#ffc000] border-[#5A3D2B]"
                                }`}
                            style={{ borderColor: "#5A3D2B" }}
                        >
                            {unreadleadcountapproved.length > 0 && (
                                <div className="absolute top-3 flex justify-center align-middle items-center">
                                    {/* <NotificationsActiveIcon
                                  className="text-black w-6 h-6"
                                /> */}
                                    <span className="  opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                        {unreadleadcountapproved.length}
                                    </span>
                                </div>
                            )}

                            <span
                                className={`text-white ${unreadleadcountapproved.length > 0
                                    ? "text-2xl font-semibold"
                                    : "text-lg"
                                    } `}
                            >
                                {approvedProjectsManagerDataPM?.length}
                            </span>
                            {showaprovedPM && (
                                <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                            )}
                        </div>
                    </div>
                    <div className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center">
                        <div className="w-[20%] flex justify-center">
                            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                                Project Assigned
                            </p>
                        </div>

                        <div
                            onClick={() => {
                                handleprojectAssign();
                            }}
                            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showassignPM
                                ? "bg-yellow-800 border-[#3a1e0a] shadow-lg"
                                : "bg-[#cfb053] border-[#5A3D2B]"
                                }`}
                            style={{ borderColor: "#5A3D2B" }}
                        >
                            {unreadleadcountassign.length > 0 && (
                                <div className="absolute top-3 flex justify-center align-middle items-center">
                                    {/* <NotificationsActiveIcon
                                  className="text-black w-6 h-6"
                                /> */}
                                    <span className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                        {unreadleadcountassign.length}
                                    </span>
                                </div>
                            )}
                            <span
                                className={`text-white ${unreadleadcountassign.length > 0
                                    ? "text-2xl font-semibold"
                                    : "text-lg"
                                    }`}
                            >
                                {assignedProjectsManagerDataPM.length}
                            </span>
                            {showassignPM && (
                                <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                            )}
                        </div>
                    </div>
                    <div className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center">
                        <div className="w-[20%] flex justify-center">
                            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                                Project Ongoing
                            </p>
                        </div>

                        <div
                            onClick={() => {
                                handleprojectOngoing();
                            }}
                            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showongoingPM
                                ? "bg-[#D27D2D] border-[#3a1e0a] shadow-lg"
                                : "bg-yellow-700 border-[#5A3D2B]"
                                }`}
                            style={{ borderColor: "#5A3D2B" }}
                        >
                            {unreadleadcountongoing.length > 0 && (
                                <div className="absolute top-3 flex justify-center align-middle items-center">
                                    {/* <NotificationsActiveIcon
                                  className="text-black w-6 h-6"
                                /> */}
                                    <span className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                        {unreadleadcountongoing.length}
                                    </span>
                                </div>
                            )}
                            <span
                                className={`text-white ${unreadleadcountongoing.length > 0
                                    ? " text-2xl font-semibold"
                                    : "text-lg"
                                    }`}
                            >
                                {ongoingProjectsManagerDataPM.length}
                            </span>
                            {showongoingPM && (
                                <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                            )}
                        </div>
                    </div>
                    <div className="flex h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center">
                        <div className="w-[20%] flex justify-center">
                            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                                Project Completed
                            </p>
                        </div>

                        <div
                            onClick={() => {
                                handleprojectCompleted();
                            }}
                            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showcompletePM
                                ? "bg-green-600 border-[#3a1e0a] shadow-lg"
                                : "bg-[#47d45a] border-[#5A3D2B]"
                                }`}
                            style={{ borderColor: "#5A3D2B" }}
                        >
                            {unreadleadcountcomplete.length > 0 && (
                                <div className="absolute top-3 flex justify-center align-middle items-center">
                                    {/* <NotificationsActiveIcon
                                  className="text-black w-6 h-6"
                                /> */}
                                    <span className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                        {unreadleadcountcomplete.length}
                                    </span>
                                </div>
                            )}
                            <span
                                className={`text-white ${unreadleadcountongoing.length > 0
                                    ? " text-2xl font-semibold"
                                    : "text-lg"
                                    }`}
                            >
                                {completeProjectsManagerDataPM.length}
                            </span>
                            {showcompletePM && (
                                <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OPMyRequestPM